import { useEffect } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export function HeroCanvas() {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 50, damping: 20 });
  const sy = useSpring(my, { stiffness: 50, damping: 20 });

  const orb1x = useTransform(sx, [-0.5, 0.5], [-50, 50]);
  const orb1y = useTransform(sy, [-0.5, 0.5], [-30, 30]);
  const orb2x = useTransform(sx, [-0.5, 0.5], [60, -60]);
  const orb2y = useTransform(sy, [-0.5, 0.5], [40, -40]);
  const chip1x = useTransform(sx, [-0.5, 0.5], [-24, 24]);
  const chip1y = useTransform(sy, [-0.5, 0.5], [-18, 18]);
  const chip2x = useTransform(sx, [-0.5, 0.5], [30, -30]);
  const chip2y = useTransform(sy, [-0.5, 0.5], [22, -22]);

  useEffect(() => {
    const onMove = (e) => {
      mx.set(e.clientX / window.innerWidth - 0.5);
      my.set(e.clientY / window.innerHeight - 0.5);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, [mx, my]);

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 grid-bg opacity-70" />
      <motion.div
        style={{ x: orb1x, y: orb1y }}
        className="absolute -top-40 -left-32 h-[480px] w-[480px] rounded-full bg-brand/25 blur-[140px]"
      />
      <motion.div
        style={{ x: orb2x, y: orb2y }}
        className="absolute -bottom-24 right-[-8%] h-[440px] w-[440px] rounded-full bg-indigo2/30 blur-[150px]"
      />
      <div className="absolute top-[30%] left-[55%] h-[300px] w-[300px] rounded-full bg-volt/10 blur-[120px]" />

      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 70, repeat: Infinity, ease: "linear" }}
        className="absolute right-[6%] top-[14%] hidden h-[420px] w-[420px] rounded-full border border-dashed border-white/15 lg:block"
      />
      <motion.div
        animate={{ rotate: -360 }}
        transition={{ duration: 50, repeat: Infinity, ease: "linear" }}
        className="absolute right-[11%] top-[22%] hidden h-[260px] w-[260px] rounded-full border border-brand/30 lg:block"
      />

      <motion.div
        style={{ x: chip1x, y: chip1y }}
        className="absolute right-[22%] top-[20%] hidden lg:block"
      >
        <motion.div
          animate={{ y: [0, -14, 0] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          className="glass rounded-xl border border-white/10 px-5 py-3 font-mono text-xs text-volt"
        >
          ROAS +312%
        </motion.div>
      </motion.div>
      <motion.div
        style={{ x: chip2x, y: chip2y }}
        className="absolute right-[9%] top-[52%] hidden lg:block"
      >
        <motion.div
          animate={{ y: [0, 12, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay: 1 }}
          className="glass rounded-xl border border-white/10 px-5 py-3 font-mono text-xs text-brand"
        >
          CAC −41%
        </motion.div>
      </motion.div>

      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-ink" />
    </div>
  );
}
